var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center my-4"},[_c('h1',[_vm._v(_vm._s(_vm.$t('errors.404.title')))]),_c('p',[_vm._v(_vm._s(_vm.$t('errors.404.description')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }